import { useField } from 'formik';
import { FC } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface IReactDatePickerProps {
  name: string;
  selectsStart?: boolean;
  showTimeSelect?: boolean;
  minDate?: Date;
  startDate?: Date;
  endDate?: Date;
  maxDate?: Date;
}

export const ReactDatePicker: FC<IReactDatePickerProps> = ({ name = "", selectsStart = false, showTimeSelect, minDate, startDate, endDate, maxDate }) => {
  const [field, meta, helpers] = useField(name);

  const { value } = meta;
  const { setValue } = helpers;

  return <DatePicker
    {...field}
    selected={value}
    onChange={(date) => setValue(date)}
    selectsStart={selectsStart}
    startDate={startDate}
    endDate={endDate}
    minDate={minDate || undefined}
    maxDate={maxDate || undefined}
    showTimeSelect={showTimeSelect}
    dateFormat={showTimeSelect ? "d MMMM yyyy h:mm aa": "d MMMM yyyy"}
    className="form-input"
  />;
}